import { Injectable } from '@angular/core';
import { FormRule, FormRuleEffect } from '../models/form-rule.model';

@Injectable({ providedIn: 'root' })
export class FormRuleFactory {
  /**
   * Creates a new FormRule that gets executed on form field update.
   * @param condition
   * @param effects
   * @returns
   */
  createRule(condition: string, effects: FormRuleEffect[]) {
    return new FormRule(condition, effects);
  }

  /**
   * Creates a new FormRule that will only get executed once on page load.
   * @param condition
   * @param effects
   * @returns
   */
  createSingleExecutionRule(condition: string, effects: FormRuleEffect[]) {
    let rule = new FormRule(condition, effects);
    rule.runContinuously = false;
    return rule;
  }

  /**
   * Creates a deep copy of the provided FormRules.
   * @param rules
   * @returns
   */
  copyRules(rules: FormRule[]): FormRule[] {
    return (JSON.parse(JSON.stringify(rules)) as Array<any>).map((i) =>
      i.runContinuously
        ? this.createRule(i.condition, i.effects)
        : this.createSingleExecutionRule(i.condition, i.effects),
    );
  }
}
